import { Phone, MessageSquare } from "lucide-react";
import { useQuoteCart } from "@/lib/quote-cart";

/**
 * Mobile-only sticky bottom bar — full width with solid background so it
 * never visually overlaps body content. Contains both Call Now and Get
 * Free Quote actions side-by-side.
 *
 * Hidden when the QuoteCart "My Order" floating button is visible (cart has
 * items) so we don't stack two CTAs on the same edge.
 *
 * Body padding-bottom (see styles.css) reserves matching space on mobile.
 */
export function MobileCallButton() {
  const { count } = useQuoteCart();
  if (count > 0) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 flex border-t-4 border-navy-deep bg-navy-deep shadow-bold md:hidden print:hidden"
      role="region"
      aria-label="Quick contact"
    >
      <a
        href="tel:+18303909588"
        aria-label="Call Texas Made Shade now"
        data-cta-placement="mobile_sticky_call_button"
        className="flex flex-1 items-center justify-center gap-2 bg-navy-deep px-3 py-3 font-display text-sm uppercase tracking-wider text-white active:scale-95"
      >
        <Phone className="h-5 w-5" />
        <span>Call Now</span>
      </a>
      <a
        href="/#lets-talk"
        aria-label="Get a free quote"
        className="flex flex-1 items-center justify-center gap-2 bg-red px-3 py-3 font-display text-sm uppercase tracking-wider text-white active:scale-95"
      >
        <MessageSquare className="h-5 w-5" />
        <span>Free Quote</span>
      </a>
    </div>
  );
}
